import React, { Component } from "react";
import { Link } from "react-router-dom";
class Home extends Component {
  state = {};
  render() {
    return (
      <div classname="container">
        <div className="col-md-12 text-center">
          <div style={{ marginTop: "425px" }}>
            <h1 style={{ fontSize: "85px" }}>SAQ GENERATOR</h1>
            {/* <Link to="/signin">Sign in</Link> | <Link to="/"> Sign up</Link> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
